import { useSettingMenuItems } from '../../../modules/settings/settingsMenuItems';
import { SettingsMenuTestIds } from '../../../utils/testIds/SettingsMenu.testIds';
import { toNavSections } from '../../utils/subNav.utils';

export const useSettingsSubNav = () => {
  const { translatedSettingsMenuItems } = useSettingMenuItems();

  return toNavSections(translatedSettingsMenuItems, {
    getTestId: (item) => `${SettingsMenuTestIds.MENU_ITEM_PREFIX}${item.name}`,
  });
};
